import { TypeSysMixin } from '../abstracts/TypeSysMixin.js';
import { AbstractNode } from '../abstracts/AbstractNode.js';

export class AbstractClassicExpr extends TypeSysMixin(AbstractNode) {}